import { LightningElement,api } from "lwc";
import { ListItem } from "./types";
export type { ListItem };

export default class ClassSessionFullDetail extends LightningElement {
    static renderMode = "light";
    @api listitem: ListItem = null!;
   
    @api buttonDetailBrandWes={
        id: "1",
        buttonLabel: {
            value: "",
            label: ""
        },
        variant: 'primary',
        size: 'default',
        showWesButton: true
    };
    @api buttonDetailIconWes={
        id: "1",
        buttonLabel: {
            value: "",
            label: ""
        },
        variant: 'primary',
        size: 'default',
        showWesButton: true
    };

    @api buttonDetailBorderWes={
    id: "1",
    buttonLabel: {
        value: "",
        label: ""
    },
    variant: 'secondary',
    size: 'default',
    showWesButton: true
    };
    

    private get hasListItem() {
        return this.listitem !== null;
    }
    
    registerHandler(){ 
        if(this.showBrandButton){
            this.dispatchEventMethod("register",{ classId: this.listitem.id, name: this.buttonDetailBrandWes.buttonLabel.value, registerFlag : this.listitem.registerFlag });
        }
        if(this.showIconButton){
            this.dispatchEventMethod("register",{ classId: this.listitem.id, name: this.buttonDetailIconWes.buttonLabel.value , registerFlag : this.listitem.registerFlag});
        }
        if(this.showBorderButton){
            this.dispatchEventMethod("register",{ classId: this.listitem.id, name: this.buttonDetailBorderWes.buttonLabel.value , registerFlag : this.listitem.registerFlag});
        }
    }

    brandButtonHandler(){ 
        if(this.showBrandButton){
            if(this.buttonDetailBrandWes.buttonLabel.value === 'register_now' || this.buttonDetailBrandWes.buttonLabel.value === 'see_cart'){
                this.dispatchEventMethod("register",{ classId: this.listitem.id, name: this.buttonDetailBrandWes.buttonLabel.value, registerFlag : this.listitem.registerFlag });
            }
        }
    }

    iconButtonHandler(){ 
        if(this.showIconButton){
            if(this.buttonDetailIconWes.buttonLabel.value === 'registered'){
                this.dispatchEventMethod("register",{ classId: this.listitem.id, name: this.buttonDetailIconWes.buttonLabel.value , registerFlag : this.listitem.registerFlag});
            }else{
                this.dispatchEventMethod("addcart",{ classId: this.listitem.id, name: this.buttonDetailIconWes.buttonLabel.value , registerFlag : this.listitem.registerFlag});
            }
        }
    }

    borderButtonHandler(){ 
        if(this.showBorderButton){
            this.dispatchEventMethod("addcart",{ classId: this.listitem.id, name: this.buttonDetailBorderWes.buttonLabel.value , registerFlag : this.listitem.registerFlag});
        }
    }

    titleHandler() {
        if(["Registered"].includes(this.listitem.registerFlag)){
            this.dispatchEventMethod("tileclick",{ classId: this.listitem?.id, name: "learningOfferingTitle", registerFlag : this.listitem?.registerFlag });
        }
    }

    dispatchEventMethod(eventName: string, eventDetail: { classId: string, name: string ,registerFlag: string}){
        this.dispatchEvent(
            new CustomEvent(eventName, {
              detail: eventDetail,
            })
        );
    }
    private get showTileLink(){
        return ["Registered"].includes(this.listitem.registerFlag) === true ? true :  false
    }

    private get showDiscount() {
        return this.listitem?.discountAmount > 0;
    }

    private get showLearningCredit() {
        return this.listitem?.learningCredits !== "" ? true : false;
    }

    private get showContactATP() {
        return ["ATP_Interest","Prospecting"].includes(this.listitem.registerFlag)
    }

    //To return Card Border Color
    private get strikeThroughText() {
        return this.listitem?.discountAmount > 0 ? "text-decoration: line-through;color: gray" : "";
    }

    private get blackTextColor() {
        return this.listitem?.discountAmount > 0 ? "color: #000000;" : "";
    }

    private get badgeColor() {
        return this.listitem?.badgeColor;
    }

    private get showConvertedTime() {
        return this.listitem?.convertedTime !== "" ? true : false;
    }
    
    //Set value "In Person Class" in order render location
    private get showInperson() {
        return this.listitem?.badgeText !== "Virtual" ? true : false;
    }  

    private get showVirtual() {
        return this.listitem?.badgeText === "Virtual" ? true : false;
    }

    private get isDisabled() {
        return ["Prospecting","Registered", "AddedToCart"].includes(this.listitem?.registerFlag) === true ? true : false;
    }

    private get showBrandButton() {
        let isBrandButton=["Waitlist", "ATP_Interest","Register","AddedToCart","Unavailable","Prospecting"].includes(this.listitem.registerFlag);
        return isBrandButton;
    }
    
    private get showIconButton() {
        let isIconButton=["Registered", "AddedToCart"].includes(this.listitem.registerFlag);
        return isIconButton;
    }

    private get showBorderButton() {
        let isBorderButton=["Registered","Waitlisted","Register"].includes(this.listitem.registerFlag);
        return isBorderButton;
    }

    connectedCallback(): void {
        this.createButtonData();
    }
    
    createButtonData(){
        if(["Waitlist"].includes(this.listitem.registerFlag)){
           let button_Brand_Object = this.listitem.buttonArr.find(btn => btn.value === 'join_waitlist');
           this.setButtonBrandData(String(button_Brand_Object?.label),String(button_Brand_Object?.value));
        }
        if([ "ATP_Interest"].includes(this.listitem.registerFlag)){
            let button_Brand_Object = this.listitem.buttonArr.find(btn => btn.value === 'register_now');
            this.setButtonBrandData(String(button_Brand_Object?.label),String(button_Brand_Object?.value));
        }
        if(["Registered"].includes(this.listitem.registerFlag)){
            let button_Border_Object = this.listitem.buttonArr.find(btn => btn.value === 'cancel_class');
            this.setButtonBorderData(String(button_Border_Object?.label),String(button_Border_Object?.value));
           
            let button_Icon_Object = this.listitem.buttonArr.find(btn => btn.value === 'registered');
            this.setButtonIconData(String(button_Icon_Object?.label),String(button_Icon_Object?.value));
        }
        if(["Register","Unavailable"].includes(this.listitem.registerFlag)){
            let button_Border_Object = this.listitem.buttonArr.find(btn => btn.value === 'add_to_cart');
            this.setButtonBorderData(String(button_Border_Object?.label),String(button_Border_Object?.value));
           
            let button_Brand_Object = this.listitem.buttonArr.find(btn => btn.value === 'register_now');
            this.setButtonBrandData(String(button_Brand_Object?.label),String(button_Brand_Object?.value));
        }
        if(["AddedToCart"].includes(this.listitem.registerFlag)){
           let button_Icon_Object = this.listitem.buttonArr.find(btn => btn.value === 'added_to_cart');
           this.setButtonIconData(String(button_Icon_Object?.label),String(button_Icon_Object?.value));
           
           let button_Brand_Object = this.listitem.buttonArr.find(btn => btn.value === 'see_cart');
           this.setButtonBrandData(String(button_Brand_Object?.label),String(button_Brand_Object?.value));
        }
        if(["Waitlisted"].includes(this.listitem.registerFlag)){
           let buttonObject = this.listitem.buttonArr.find(btn => btn.value === 'cancel_waitlist');
            this.setButtonBorderData(String(buttonObject?.label),String(buttonObject?.value));
        }
        if(["Prospecting"].includes(this.listitem.registerFlag)){
           let button_Brand_Object = this.listitem.buttonArr.find(btn => btn.value === 'interest_submitted');
           this.setButtonBrandData(String(button_Brand_Object?.label),String(button_Brand_Object?.value));
        }
    }
    
    setButtonBrandData(buttonLabel : string,buttonValue : string){
        this.buttonDetailBrandWes.buttonLabel.label=buttonLabel;
        this.buttonDetailBrandWes.buttonLabel.value=buttonValue;
    }

    setButtonBorderData(buttonLabel : string,buttonValue : string){
        this.buttonDetailBorderWes.buttonLabel.label=buttonLabel;
        this.buttonDetailBorderWes.buttonLabel.value=buttonValue;
    }

    setButtonIconData(buttonLabel : string,buttonValue : string){
        this.buttonDetailIconWes.buttonLabel.label=buttonLabel;
        this.buttonDetailIconWes.buttonLabel.value=buttonValue;
    }

    private get isSingleButtonShow() {
        let isSingleButton=[ "Waitlist","ATP_Interest","Waitlisted","Unavailable","Prospecting"].includes(this.listitem.registerFlag);
        return isSingleButton;
    }

    private get isDoubleButtonShow() {
        let isDoubleButton=["Register","Registered","AddedToCart"].includes(this.listitem.registerFlag);
        return isDoubleButton;
    }
}